import type { UserVehicle } from "@spare-cart/contracts/vehicles";
import type { ShopForVehicleSelection } from "../hooks/useShopForVehicle";

const formatVehicle = (vehicle: UserVehicle): string => {
  const parts = [vehicle.makeName, vehicle.modelName];
  if (vehicle.variantName !== null) parts.push(vehicle.variantName);
  if (vehicle.year !== null) parts.push(String(vehicle.year));
  return parts.join(" · ");
};

export const toShopForVehicleSelection = (vehicle: UserVehicle): ShopForVehicleSelection => ({
  id: vehicle.id,
  title: vehicle.nickname ?? formatVehicle(vehicle),
  subtitle: vehicle.nickname === null ? null : formatVehicle(vehicle),
  vehicleTypeId: vehicle.vehicleTypeId,
  makeId: vehicle.makeId,
  modelId: vehicle.modelId,
  variantId: vehicle.variantId,
  year: vehicle.year,
  userVehicleId: vehicle.id,
});
